export default "__VITE_ASSET__d578c44f__"